import { createAction } from "@redux/actions/actionCreators";

const [useRemoveProductAsset, removeProductAsset] = createAction<{
  productUuid: string;
  /** Variant key to remove from, or null for the product level. */
  variantKey: string | null;
  /** The product field ID of the asset-typed field (e.g. "images"). */
  productFieldId: string;
  /** UUID of the asset to remove. */
  assetUuid: string;
}>("product/removeAsset");

export default useRemoveProductAsset;
export { removeProductAsset };
